import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SettingsGlobalState, defaultSettingsGlobalState } from './types';

export const settingsSlice = createSlice({
  name: 'settings',
  initialState: defaultSettingsGlobalState,
  reducers: {
    isOpenPatientPageAfterCreationChanged: (
      state,
      action: PayloadAction<boolean>,
    ): SettingsGlobalState => {
      return {
        ...state,
        isOpenPatientPageAfterCreation: action.payload,
      };
    },
    isOpenVisitAfterCreationChanged: (
      state,
      action: PayloadAction<boolean>,
    ): SettingsGlobalState => {
      return {
        ...state,
        isOpenVisitAfterCreation: action.payload,
      };
    },
    isNightThemeChanged: (
      state,
      action: PayloadAction<boolean>,
    ): SettingsGlobalState => {
      return {
        ...state,
        isNightTheme: action.payload,
      };
    },
    resourceTypesWithEnabledAnyAvailableChanged: (
      state,
      action: PayloadAction<string[]>,
    ): SettingsGlobalState => {
      return {
        ...state,
        resourceTypesWithEnabledAnyAvailable: action.payload,
      };
    },
  },
});

export const SettingsActions = settingsSlice.actions;
